import { takeEvery, put, select, all, call } from "redux-saga/effects";
import { request } from "util/api/client";
import { pending } from "state/actions/ui";
import { storeList } from "state/actions/data";

function* handleUpdateInfo({ payload, context }) {
    const { id } = payload;
    try {
        yield put(pending("console.domains", true));
        const url = id
            ? `console/domains/${id}/update-info`
            : `console/domains/update-info`;
        const response = yield request({
            method: "post",
            url,
            context,
        });
        yield put(
            storeList(
                "console.domains",
                "console.domains/console.domains",
                response.data.data
            )
        );
        yield put(pending("console.domains", false));
    } catch (e) {
        yield put(pending("console.domains", false));
    }
}

function* handleRenewCertificates({ payload, context }) {
    const { id } = payload;
    try {
        yield put(pending("console.domains", true));
        const url = id
            ? `console/domains/${id}/renew-certificate`
            : `console/domains/renew-certificate`;
        const response = yield request({
            method: "post",
            url,
            context,
        });
        yield put(pending("console.domains", false));
    } catch (e) {
        yield put(pending("console.domains", false));
    }
}

export default function* () {
    yield takeEvery("CONSOLE.DOMAINS.UPDATE_INFO", handleUpdateInfo);
    yield takeEvery(
        "CONSOLE.DOMAINS.RENEW_CERTIFICATES",
        handleRenewCertificates
    );
}
